export const development_mode = false;
const Constant = {
  BASE_URL: development_mode
    ? "https://api.bulls-ai.co/api"
    : "https://api.bulls-ai.co/api",
  COLOR_PALLETE: {
    background: {
      primary: "#2DD4BF",
      secondary: "#FFFFFF",
      gd: `linear-gradient(94.25deg, #010720 0%, #003024 100%)`,
    },
    white: "#FFFFFF",
  },
};
export default Constant;
